/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize SchedulingAlert View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './SchedulingAlertView';

export const mapStateToPropsSchedulingAlert = mapStateToProps;
export const mapDispatchToPropsSchedulingAlert = mapDispatchToProps;

export default connect(
  mapStateToPropsSchedulingAlert,
  mapDispatchToPropsSchedulingAlert
)(View);
